import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import axios from "axios";
import {
  formatMoneda,
  formatoMonto,
  validaMonto,
  validaSoloNumero,
} from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoCatProgramatica from "../../catalogos/catalogoCategoriaProgramatica";
import CatalogoClassPresupuestaria from "../../catalogos/catalogoClassPresupuestario";

export const ActualizarPresupuesto = (props) => {
  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [val, setVal] = useState(0);
  const [val2, setVal2] = useState(0);
  const [idcat, setIdcat] = useState(0);
  const [idpc, setIdpc] = useState(0);
  const [cat, setCat] = useState(0);
  const [pucc, setPucc] = useState(0);
  const [activo, setActivo] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtIdd = useRef();
  const txtTipoPartidai = useRef();
  const txtTipoPartidag = useRef();
  const txtDescricat = useRef();
  const txtDescriclas = useRef();
  const txtDescriaux = useRef();
  const txtMonto = useRef();
  const txtAuxiliar = useRef();
  const txt1 = useRef();
  const txt2 = useRef();
  const txt3 = useRef();
  const txt4 = useRef();
  const txt5 = useRef();
  const txt6 = useRef();
  const txt7 = useRef();
  const txt8 = useRef();
  const txt9 = useRef();

  const onChange = (event) => {};

  const onCheck = () => {
    if (txtTipoPartidai.current.checked) {
      setVal(100000000);
      setVal2(399999999);
      setActivo(false);
    } else if (txtTipoPartidag.current.checked) {
      setVal(400000000);
      setVal2(999999999);
      setActivo(false);
    }
  };
  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (
      txtTipoPartidai.current.checked === false &&
      txtTipoPartidag.current.checked === false
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Tipo de Partida",
        icono: "informacion",
      });
      sigue = false;
      txtTipoPartidai.current.focus();
    } else if (txt1.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Categoria Programatica",
        icono: "informacion",
      });
      sigue = false;
      txt1.current.focus();
    } else if (txt6.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Clasificador Presupuestario",
        icono: "informacion",
      });
      sigue = false;
      txt6.current.focus();
    } else if (txtAuxiliar.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Auxiliar no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtAuxiliar.current.focus();
    } else if (txtMonto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca el Monto del Presupuesto",
        icono: "informacion",
      });
      sigue = false;
      txtMonto.current.focus();
    } else if (sigue) {
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Reversar esta Cuenta?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/crearpresupuesto`;
    let body;
    setActivate(true);

    body = {
      m_cCat: cat.trim(),
      m_cCta: pucc.trim(),
      m_cAux: txtAuxiliar.current.value.trim(),
      m_cDescAux: txtDescriaux.current.value.trim(),
      m_nMontoInicial: parseFloat(
        txtMonto.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
      m_nEfiscal: idefiscal,
      m_nIdCatPro: parseInt(idcat),
      m_nIdPuc: parseInt(idpc),
      m_cSecgeo: "",
      m_nTippar: 0,
      m_usu: parseInt(idusuario),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Presupuesto Creado Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const Reversar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/reversarpresupuesto`;
    let body;
    setActivate(true);

    body = {
      m_cCat: props.presu.categoria.trim(),
      m_cCta: props.presu.puc.trim(),
      m_cAux: txtAuxiliar.current.value.trim(),
      m_cDescAux: txtDescriaux.current.value.trim(),
      m_nEfiscal: idefiscal,
      m_nIdCatPro: parseInt(props.presu.idcategoriaprogramatica),
      m_nIdPuc: parseInt(props.presu.idpuc),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "La Cuenta-" +
                props.presu.idcuenta +
                "-Fue Reversada Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setActivate(false);
  };

  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    } else if (operacion === 2) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Reversar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const catalogoCat = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const catalogoClass = (e) => {
    e.preventDefault();
    setMostrar4(true);
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.which === 13) {
        if (event.target.id === "monto") {
          txtMonto.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleAceptaCatProgramatica = (
    idcategoriaprogramatica,
    descripcion,
    categoriaprogramatica
  ) => {
    setMostrar3(false);

    txtDescricat.current.value = descripcion.trim();
    txt1.current.value = categoriaprogramatica.substring(0, 2);
    txt2.current.value = categoriaprogramatica.substring(2, 4);
    txt3.current.value = categoriaprogramatica.substring(4, 6);
    txt4.current.value = categoriaprogramatica.substring(6, 8);
    txt5.current.value = categoriaprogramatica.substring(8, 10);
    setCat(categoriaprogramatica);
    setIdcat(idcategoriaprogramatica);
  };

  const handleAceptaClasPresupuestaria = (idpuc, descripcion, puc) => {
    setMostrar3(false);

    txtDescriclas.current.value = descripcion.trim();
    txt6.current.value = puc.substring(0, 3);
    txt7.current.value = puc.substring(3, 5);
    txt8.current.value = puc.substring(5, 7);
    txt9.current.value = puc.substring(7, 9);
    setPucc(puc);
    setIdpc(idpuc);
  };

  const handleCancelara = () => {
    setMostrar3(false);
  };

  const handleCancelaras = () => {
    setMostrar4(false);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.presu);
        } else {
          txtTipoPartidag.current.checked = false;
          txtTipoPartidai.current.checked = false;
          txtDescricat.current.value = "";
          txtDescriclas.current.value = "";
          txt1.current.value = "";
          txt2.current.value = "";
          txt3.current.value = "";
          txt4.current.value = "";
          txt5.current.value = "";
          txt6.current.value = "";
          txt7.current.value = "";
          txt8.current.value = "";
          txt9.current.value = "";
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Crear Presupuesto."
              : operacion === 2
              ? "Editar Presupuesto."
              : operacion === 3
              ? "Eliminar Presupuesto."
              : "Consultar Presupuesto."}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <CatalogoCatProgramatica
          show={mostrar3}
          onHideCancelar={handleCancelara}
          onHideAceptaCatProgramatica={handleAceptaCatProgramatica}
        />
        <CatalogoClassPresupuestaria
          show={mostrar4}
          val={val}
          vals={val2}
          onHideCancelar={handleCancelaras}
          onHideAceptaClasPresupuestaria={handleAceptaClasPresupuestaria}
        />
        <Dimmer active={activate} />
        <div className="container-fluid rounded">
          <div className="tab-content" id="ex-with-icons-content">
            <div
              className="tab-pane fade show active"
              id="tab-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <fieldset className="row border-azul rounded mx-auto">
                <legend className="float-none m-0 w-auto">Datos</legend>

                <div className="col-sm-4">
                  <div className="input-group py-1 input-group-sm ">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Código Cuenta:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      disabled={true}
                      ref={txtIdd}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      value={values ? values.idcuenta.trim() : ""}
                      id="inputCedula"
                    />
                  </div>
                </div>

                <fieldset className="row border-azul rounded mx-auto col-sm-7">
                  <legend className="float-none m-0 w-auto">
                    Tipo de Partida
                  </legend>

                  <div className="form-check col-sm-4 ml-auto">
                    <input
                      className="form-check-input"
                      disabled={
                        operacion === 4 || operacion === 2
                          ? true
                          : deshabilitado
                      }
                      type="radio"
                      ref={txtTipoPartidai}
                      onChange={onCheck}
                      defaultChecked={
                        props.presu && props.presu.tipopartida === 0
                          ? true
                          : false
                      }
                      name="exampleRadios"
                      id="exampleRadios1"
                      value="option1"
                    />
                    <label className="form-check-label" for="exampleRadios1">
                      Ingresos
                    </label>
                  </div>
                  <div className="form-check col-sm-4 ml-auto">
                    <input
                      className="form-check-input"
                      disabled={
                        operacion === 4 || operacion === 2
                          ? true
                          : deshabilitado
                      }
                      type="radio"
                      ref={txtTipoPartidag}
                      onChange={onCheck}
                      defaultChecked={
                        props.presu && props.presu.tipopartida !== 0
                          ? true
                          : false
                      }
                      name="exampleRadios"
                      id="exampleRadios2"
                      value="option2"
                    />
                    <label className="form-check-label" for="exampleRadios2">
                      Gastos
                    </label>
                  </div>
                </fieldset>
              </fieldset>

              <div className="col-md-12 py-2"></div>

              <fieldset className="row border-azul rounded mx-auto">
                <legend className="float-none m-0 w-auto">
                  Categoria Programatica
                </legend>

                <div className="container row m-0 d-flex justify-content-center">
                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Sector:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="uno"
                      ref={txt1}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              0,
                              2
                            )
                          : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Prog:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="dos"
                      ref={txt2}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              2,
                              4
                            )
                          : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-2 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      SubProg:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="tres"
                      ref={txt3}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              4,
                              6
                            )
                          : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Proy:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="cuatro"
                      ref={txt4}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              6,
                              8
                            )
                          : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Act:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="cinco"
                      ref={txt5}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              8,
                              10
                            )
                          : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                    <button
                      disabled={
                        operacion === 4 || operacion === 2 ? true : activo
                      }
                      onClick={catalogoCat}
                      className="btn btn-sm  btn-info ml-2"
                    >
                      <i className="fa fa-search"></i>{" "}
                    </button>
                  </div>
                </div>

                <div className="container row m-0">
                  <div className="input-group py-1 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Descripción:
                    </label>
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      disabled={true}
                      ref={txtDescricat}
                      defaultValue={
                        props.categoria ? props.categoria.descripcion : ""
                      }
                      placeholder="Descripción de la Categoria Programatica"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputDireccion"
                    />
                  </div>
                </div>
              </fieldset>

              <div className="col-md-12 py-2"></div>

              <fieldset className="row border-azul rounded mx-auto">
                <legend className="float-none m-0 w-auto">
                  Clasificador Presupuestario
                </legend>

                <div className="container row m-0 d-flex justify-content-center col-11 mx-auto">
                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Ramo:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="3"
                      name="uno"
                      ref={txt6}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.claspre ? props.claspre.puc.substring(0, 3) : ""
                      }
                      className="form-control text-uppercase col-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Gen:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="dos"
                      ref={txt7}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.claspre ? props.claspre.puc.substring(3, 5) : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-2 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Espec:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="tres"
                      ref={txt8}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.claspre ? props.claspre.puc.substring(5, 7) : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-3 px-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      SubEsp:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="cuatro"
                      ref={txt9}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.claspre ? props.claspre.puc.substring(7, 9) : ""
                      }
                      className="form-control text-uppercase col-3 px-2"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                    <button
                      disabled={
                        operacion === 4 || operacion === 2 ? true : activo
                      }
                      onClick={catalogoClass}
                      className="btn btn-sm  btn-info ml-2"
                    >
                      <i className="fa fa-search"></i>{" "}
                    </button>
                  </div>
                </div>

                <div className="container row m-0">
                  <div className="input-group py-1 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Descripción:
                    </label>
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      disabled={true}
                      ref={txtDescriclas}
                      defaultValue={
                        props.claspre ? props.claspre.descripcion : ""
                      }
                      placeholder="Descripción del Clasificador Presupuestario"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputDireccion"
                    />
                  </div>
                </div>

                <fieldset className="row border-azul rounded mx-auto">
                  <div className="container row m-0">
                    <div className="input-group py-1 input-group-sm col-sm-3">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Auxiliar:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control text-uppercase col-4"
                        maxLength="4"
                        disabled={
                          operacion === 4 || operacion === 2
                            ? true
                            : deshabilitado
                        }
                        ref={txtAuxiliar}
                        defaultValue={
                          props.presu && props.presu.auxiliar !== null
                            ? props.presu.auxiliar
                            : "0000"
                        }
                        placeholder="0000"
                        onChangeCapture={handleInputNumChange}
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputDireccion"
                      />
                    </div>
                  </div>
                  <div className="container row m-0">
                    <div className="input-group py-1 input-group-sm col-sm-12">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Descripción Auxiliar:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control text-uppercase"
                        disabled={
                          operacion === 4 || operacion === 2
                            ? true
                            : deshabilitado
                        }
                        ref={txtDescriaux}
                        defaultValue={
                          values ? values.descripcionaux.trim() : ""
                        }
                        placeholder="Descripción del Auxiliar"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputDireccion"
                      />
                    </div>
                  </div>
                  <div className="container row m-0">
                    <div className="input-group py-1 input-group-sm col-sm-4">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Monto:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control text-right"
                        disabled={
                          operacion === 4 || operacion === 2
                            ? true
                            : deshabilitado
                        }
                        ref={txtMonto}
                        defaultValue={
                          values && values.montoinicial
                            ? formatMoneda(
                                values.montoinicial
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                            : ""
                        }
                        onBlur={handleInputMontoChange}
                        onKeyUp={handleInputMontoChange}
                        placeholder="0,00"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="monto"
                      />
                    </div>
                  </div>
                </fieldset>
              </fieldset>

              <div className="col-md-12 py-1"></div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          ref={btnAcepta}
          onClick={onChangeValidar}
          disabled={operacion === 4 ? true : false}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-success btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i>Aceptar
        </button>
        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i>Cancelar
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/presupuesto/modalActuPresupuestos.js